import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { isContractTypeCep18 } from '@block-explorer/entities';
import {
  FULL_PRECISION,
  FlexRow,
  TableData,
  TableRow,
} from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';
import { getDictionaryPathByHash } from '../../utils/dictionary';
import { TableDataCep18TokenInfo } from '../table-data-cep18-token-info/table-data-cep18-token-info';
import FiatCurrency from '../multi-currency/multi-currency';
import { TableDataCurrencyAmount } from '../table-data-currency-amount/table-data-currency-amount';
import { DexButton } from '../dex-button/dex-button';
import { TokensBalanceSummary } from '../../services';

interface Cep18TokenItemProps {
  data: TokensBalanceSummary;
  hash: string;
  loading: boolean;
}

export const Cep18TokenItem = ({
  data,
  hash,
  loading,
}: Cep18TokenItemProps) => {
  const tokenBalance = data.tokenBalance;
  const cep18AmountData = data.cep18AmountData;
  const isCep18 = isContractTypeCep18(data.contractPackage);

  const { symbol, volume_24h, price, website, iconPath, decimals, label } =
    cep18AmountData;

  if (loading) {
    return (
      <TableRow>
        <TableData rowSpan={2}>
          <Skeleton />
        </TableData>
      </TableRow>
    );
  }

  const balanceUref = data?.contractPackage?.metadata?.balances_uref;
  const purseUrefPath = getDictionaryPathByHash(
    hash,
    balanceUref,
    data?.owner_type
  );

  return (
    <TableRow>
      <TableData>
        {symbol && (
          <TableDataCep18TokenInfo
            data={data?.contractPackage}
            loading={loading}
            symbol={symbol}
          />
        )}
      </TableData>
      <TableData>
        <BodyText size={3} monotype noWrap>
          {price ? (
            <FiatCurrency
              amount={price.toString()}
              precision={FULL_PRECISION}
            />
          ) : (
            '-'
          )}
        </BodyText>
      </TableData>
      {/*<TableData>*/}
      {/*  <BodyText size={3} monotype noWrap>*/}
      {/*    {volume_24h != null ? (*/}
      {/*      <MarketPriceChange volume24h={volume_24h} />*/}
      {/*    ) : (*/}
      {/*      '-'*/}
      {/*    )}*/}
      {/*  </BodyText>*/}
      {/*</TableData>*/}
      <TableData align={'right'}>
        <TableDataCurrencyAmount
          amount={tokenBalance || '0'}
          cep18AmountData={isCep18 ? cep18AmountData : null}
          purseUrefPath={purseUrefPath}
          loading={loading}
          showSymbol={false}
          showFiatValue
        />
      </TableData>
      <TableData align={'center'}>
        {website ? (
          <FlexRow align="center" justify={'center'} gap={12}>
            <DexButton
              iconPath={iconPath}
              label={label}
              onClick={() => {
                window.open(website, '_blank', 'noopener');
              }}
            />
          </FlexRow>
        ) : null}
      </TableData>
    </TableRow>
  );
};

export default Cep18TokenItem;
